import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

export const DEEP_RESEARCH_ANALYTICS_ACTIONS = {
  SAVED_DEEP_RESEARCH_TO_ENTRY: {
    module: ANALYTICS_MODULE.DEEP_RESEARCH,
    action: 'saved_deep_research_to_entry',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  CLICKED_DEEP_RESEARCH_CITATION: {
    module: ANALYTICS_MODULE.DEEP_RESEARCH,
    action: 'clicked_deep_research_citation',
    actionCategory: ACTION_CATEGORY.READ,
  },
};
